export default __webpack_public_path__ + "static/media/project4.078ccf39.png";